module.exports = __webpack_public_path__ + "/images/ico-vendedores-movil.f47588f.svg";